export const system = {
  success: { light: "#22c55e", dark: "#4caf50" },
  warning: { light: "#fbbf24", dark: "#ff9800" },
  error:   { light: "#ef4444", dark: "#f44336" },
  info:    { light: "#3b82f6", dark: "#2196f3" }
};
